import * as React from 'react';

import { Button } from 'antd';
import { PiWarningOctagonFill } from 'react-icons/pi';
import TMIcon from 'tm-icons-library';
import { IconName } from 'tm-icons-library/dist/IconTypes';

import CustomParsedReadMoreContent
  from '../../../../components/CustomReadMoreText/CustomParsedReadMoreContent';
import Rupee from '../../../../components/Rupee/Rupee';
import { useTheme } from '../../../../context/ThemeProvider';
import { newNumberFormat } from '../../../../shared/utils';
import { IRenewMango } from './types';

interface Props {
  renewMango: IRenewMango;
  onClick: () => void;
}

const RenewMangoTile: React.FC<Props> = ({ renewMango, onClick }) => {
  const { colors: COLORS } = useTheme();

  return (
    <div
      className={`feed-card danger`}
      onClick={onClick}
      style={{
        border: `1px solid ${COLORS.DANGER}`,
        borderLeft: 0,
        borderRight: 0,
      }}>
      <div
        className="feed-card__icon-bar"
        style={{
          // paddingTop: 12,
          // alignItems: 'start',
          backgroundColor: 'transparent',
        }}>
        {renewMango?.mango?.customRenewCardAfterExpiry?.icon ? (
          <TMIcon
            name={
              renewMango?.mango?.customRenewCardAfterExpiry?.icon as IconName
            }
            size={20}
            color={COLORS.DANGER}
          />
        ) : (
          <PiWarningOctagonFill size={20} color={COLORS.DANGER} />
        )}
      </div>

      <div className="feed-card__details-wrapper" style={{ paddingLeft: 4 }}>
        <div className="feed-card-details">
          <div className="feed-card__title" style={{ fontSize: 14 }}>
            {renewMango?.mango?.customRenewCardAfterExpiry?.message ? (
              <CustomParsedReadMoreContent
                text={renewMango?.mango?.customRenewCardAfterExpiry?.message}
                style={{ fontSize: 14 }}
              />
            ) : (
              <b>{renewMango.mango.title}</b>
            )}
          </div>

          <div className="feed-card__subtitle">
            {renewMango?.mango?.customRenewCardAfterExpiry?.buttonText ? (
              <Button
                type="link"
                className="siteBtn siteBtnLink sm"
                onClick={onClick}
                style={{ color: COLORS.LINK }}>
                {renewMango?.mango?.customRenewCardAfterExpiry?.buttonText}
              </Button>
            ) : (
              <>
                Renew now for <Rupee />
                {newNumberFormat(renewMango.mango.price)}
              </>
            )}
          </div>
        </div>

        {/* <div className="feed-card__arrow">
          <IoChevronForward size={24} color={COLORS.ICON} />
        </div> */}
      </div>
    </div>
  );
};

export default React.memo(RenewMangoTile);
